/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { UpdateEncounterBirthdayErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const updatePatientEncountersBirthday = (patientId: string, encounterId: number) => {
  return api<void>({
    url: `/api/patient/${patientId}/encounters/${encounterId}/birthday`,
    method: 'PUT',
  });
};

export const getUpdatePatientEncountersBirthdayMutationOptions = <
  TError = UpdateEncounterBirthdayErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatientEncountersBirthday>>,
    TError,
    { patientId: string; encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatientEncountersBirthday>>,
  TError,
  { patientId: string; encounterId: number },
  TContext
> => {
  const mutationKey = ['updatePatientEncountersBirthday'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientEncountersBirthday>>,
    { patientId: string; encounterId: number }
  > = (props) => {
    const { patientId, encounterId } = props ?? {};

    return updatePatientEncountersBirthday(patientId, encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientEncountersBirthdayMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientEncountersBirthday>>
>;

export type UpdatePatientEncountersBirthdayMutationError = UpdateEncounterBirthdayErrorResponse;

export const useUpdatePatientEncountersBirthday = <
  TError = UpdateEncounterBirthdayErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatientEncountersBirthday>>,
      TError,
      { patientId: string; encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatientEncountersBirthday>>,
  TError,
  { patientId: string; encounterId: number },
  TContext
> => {
  const mutationOptions = getUpdatePatientEncountersBirthdayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
